import React, { useState } from 'react';

import { WelcomeScreen } from './components/WelcomeScreen';
import { AnalysisPanel } from './components/AnalysisPanel';

export default function App({ data, exampleDataLink, exampleInformationLink }) {
  const [showingWelcomeScreen, setShowingWelcomeScreen] = useState(true);
  const [projectData, setProjectData] = useState(
    Object.keys(data).length > 0 ? data : null,
  );
  return (
    <>
      <div className="hero min-h-[60vh] bg-base-200/60 xl:hidden">
        <div className="hero-content text-center max-w-xl">
          <div className="card card-bordered bg-base-100 border-primary">
            <div className="card-body items-center gap-4">
              <div className="badge badge-primary badge-outline px-4 py-3 gap-2">
                <span className="text-sm font-semibold tracking-wide uppercase">
                  ATE
                </span>
                <span className="text-xs font-medium normal-case opacity-80">
                  1280&nbsp;px+
                </span>
              </div>
              <h2 className="card-title text-center">
                Pełny panel dostępny na większym ekranie
              </h2>
              <p className="text-base-content/70">
                Panel ATE korzysta z rozbudowanych wykresów i tabel, które do
                komfortowej pracy wymagają przestrzeni roboczej dostępnej na
                urządzeniach desktopowych.
              </p>
              <p className="text-sm text-base-content/60">
                Powiększ okno przeglądarki lub przełącz się na monitor o
                szerokości co najmniej 1280&nbsp;px, aby kontynuować pracę w
                aplikacji ATE.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden xl:block">
        {showingWelcomeScreen ? (
          <WelcomeScreen
            setProjectData={setProjectData}
            file={projectData?.file}
            setShowingWelcomeScreen={setShowingWelcomeScreen}
            exampleDataLink={exampleDataLink}
            exampleInformationLink={exampleInformationLink}
          />
        ) : (
          <AnalysisPanel
            projectData={projectData}
            setProjectData={setProjectData}
            setShowingWelcomeScreen={setShowingWelcomeScreen}
          />
        )}
      </div>
    </>
  );
}
